// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainCard {
  width: 100%;
  border-radius: 0.75rem;
  border: 1px solid #FF6B00;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  background-image: linear-gradient(#FFF1E6 10%, white 90%);
}

.mainContent {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content {
  width: 100%;
  padding: 0.6rem;
}

.title {
  font-size: 0.75rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  text-align: right;
}

.actionContainer {
  display: flex;
  width: 25px;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #B3CDE0;
  border-top-left-radius: 0.7rem;
  border-bottom-left-radius: 0.7rem;
  padding: 0.7rem 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/EducationalCard/ed.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,sCAAA;EACA,yDAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,8BAAA;EACA,iCAAA;EACA,sBAAA;AACF","sourcesContent":[".mainCard {\n  width: 100%;\n  border-radius: 0.75rem;\n  border: 1px solid #FF6B00;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  background-image: linear-gradient( #FFF1E6 10%, white 90% ,);\n}\n\n.mainContent {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.content {\n  width: 100%;\n  padding: 0.6rem;\n}\n\n.title {\n  font-size: 0.75rem;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  text-align: right;\n}\n\n.actionContainer {\n  display: flex;\n  width: 25px;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #B3CDE0;\n  border-top-left-radius: 0.7rem;\n  border-bottom-left-radius: 0.7rem;\n  padding: 0.7rem 0.2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
